import { queryClient } from '@/lib/react-query';
import {
  CreateDTO,
  useCreateMutationFactory,
  UseCreateMutationProps,
} from '@/lib/react-query/create';
import { Task } from '@/types';
import { create } from '@/utils/api';
import { featureKeys, featurePath, TaskSearchParams } from '.';

export type CreateTaskDTO = CreateDTO<Task, TaskSearchParams>;

const createTask = ({ data, params = {} }: CreateTaskDTO) =>
  create<Task>(`${featurePath}`, data, params);

export const useCreateTask = (options?: UseCreateMutationProps<Task>) => {
  return useCreateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: createTask,
    onSuccess: (data) => {
      if (data.parent_task_id !== null) {
        queryClient.invalidateQueries({
          queryKey: [{ scope: 'task', entity: 'detail', id: data.parent_task_id }],
        });
        if (data.parent_task?.taskable_type && data.parent_task?.taskable_id) {
          queryClient.invalidateQueries({
            queryKey: [
              {
                scope: data.parent_task.taskable_type,
                entity: 'detail',
                id: data.parent_task.taskable_id,
              },
            ],
          });
        }
      }
    },
    ...options,
  });
};
